module.exports = __webpack_public_path__ + "static/media/bananaSmoothie.77611033.jpg";